//#region IMPORT
import React, { useEffect } from 'react';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import { getColumnDefs1 } from './SAT_BASIC_07_ColumnDefs';
import { useSelector } from 'react-redux';

function SAT_BASIC_07(props) {
  const searchInfo = useSelector((state) => state.SearchInfo);
  const columnDefs = getColumnDefs1(props);

  //#region AuthButton 이벤트

  useEffect(() => {
    const {
      filterClick7,
      searchClick7,
      addClick7,
      saveClick7,
      printClick7,
      validateSelection,
      setFilterClick7,
      setSearchClick7,
      setAddClick7,
      setSaveClick7,
      setPrintClick7,
      ResetLogicAll,
      SearchLogic1,
      SaveLogic1,
      PrintLogic1,
      setChangedRowData1,
    } = props;

    if (filterClick7) {
      if (!validateSelection()) {
        setFilterClick7(false);
        return;
      }

      props.gridRef.current.api.setQuickFilter(searchInfo.searchText);
      setFilterClick7(false);
    }
    if (searchClick7) {
      ResetLogicAll();
      if (!validateSelection()) {
        setSearchClick7(false);
        return;
      }

      SearchLogic1();
      setSearchClick7(false);
    }
    if (addClick7) {
      if (!validateSelection()) {
        setAddClick7(false);
        return;
      }

      GridFunctions.addClick(props.gridRef, setChangedRowData1);
      setAddClick7(false);
    }
    if (saveClick7) {
      if (!validateSelection()) {
        setSaveClick7(false);
        return;
      }

      SaveLogic1();
      setSaveClick7(false);
    }

    if (printClick7) {
      if (!validateSelection()) {
        setPrintClick7(false);
        return;
      }

      PrintLogic1();
      setPrintClick7(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.filterClick7,
    props.searchClick7,
    props.addClick7,
    props.saveClick7,
    props.deleteClick7,
    props.printClick7,
  ]);

  //#endregion
  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={(params) => {
          return params.data.no;
        }}
        deleteYn1={'N'}
        gridRef={props.gridRef}
        columnDefs={columnDefs}
        rowData={props.rowData1}
        setChangedRowData={props.setChangedRowData1}
        setSelectedRowData={props.setSelectedRowData1}
        flex={1}
        title1="교육관리(대상자별)"
        addYn1="N"
        printYn1="N"
        addClick1={() => {
          if (!props.validateSelection()) return;

          GridFunctions.addClick(props.gridRef, props.setChangedRowData1);
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
        deleteClick1={(e) => {
          if (!props.validateSelection()) return;

          const newRowExists = props.selectedRowData1.some(
            (row) => row.newYn === 'Y'
          );

          if (!newRowExists) {
            props.MarkedForDeletion1(props.selectedRowData1);
          } else {
            props.NewYnErrorMsg();
          }
        }}
        onCellClicked={(e) => {
          const gridApi = props.gridRef.current.api;
          const clickedRowIndex = e.rowIndex;
          const clickedColumn = e.column?.getColId();

          const isCheckboxClick = e.event?.target?.type === 'checkbox';
          // editable이 함수인 경우도 처리
          const isEditableCell =
            typeof e.colDef?.editable === 'function'
              ? e.colDef.editable(e)
              : e.colDef?.editable === true;

          if (!isCheckboxClick) {
            gridApi.ensureIndexVisible(clickedRowIndex, 'middle');

            // 편집 가능한 셀인 경우 편집 모드로 진입
            if (isEditableCell) {
              const copied = JSON.parse(JSON.stringify(e.data));
              props.handleRowSelection(copied, clickedRowIndex);

              gridApi
                .getDisplayedRowAtIndex(clickedRowIndex)
                ?.setSelected(true, false);

              // 편집 모드로 진입
              gridApi.startEditingCell({
                rowIndex: clickedRowIndex,
                colKey: clickedColumn,
              });
            } else {
              gridApi.setFocusedCell(clickedRowIndex, 'USER_NM');

              const copied = JSON.parse(JSON.stringify(e.data));
              props.handleRowSelection(copied, clickedRowIndex);

              gridApi
                .getDisplayedRowAtIndex(clickedRowIndex)
                ?.setSelected(true, false);
            }
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef.current?.api;
          if (!gridApi) return;

          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);

          // selectedRowNosRef 업데이트 (GridCheckBoxFunction과 동기화)
          props.selectedRowNosRef.current = new Set(
            selectedData.map((r) => r.no)
          );

          props.setSelectedRowData1(selectedData);
        }}
        onCellValueChanged={(e) => {
          const key = e.data.no;
          const field = e.colDef.field;

          if (field === 'alarmYn' || field === 'alarmGubun') {
            const updatedData = {
              ...e.data,
              [field]: e.newValue, // 변경된 필드의 최신 값 반영
              editYn: 'Y',
            };

            if (
              field === 'alarmYn' &&
              (e.newValue === 'Y' || e.newValue === 'y')
            ) {
              if (!updatedData.alarmGubun || updatedData.alarmGubun === '') {
                updatedData.alarmGubun = '0';
                e.node.setDataValue('alarmGubun', '0');
              }
            }

            if (
              field === 'alarmYn' &&
              (e.newValue === 'N' || e.newValue === 'n')
            ) {
              updatedData.alarmGubun = '';
              e.node.setDataValue('alarmGubun', '');
            }

            e.node.setData(updatedData);

            props.setChangedRowData1?.((prev) => {
              const filtered = prev.filter((row) => row.no !== key);
              return [...filtered, updatedData];
            });
          }
        }}
      />
    </React.Fragment>
  );
}

export default SAT_BASIC_07;
